import React, { useState, useEffect } from 'react';
import { withApollo } from 'react-apollo';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { getEducationTags } from 'GraphQL/query/EduTag.query';
import { isLogin } from 'Redux/user-profile/selectors';

export const GlobalDataContext = React.createContext({});

export const GlobalDataProvider = compose(
  connect(state => ({ isLoggedIn: isLogin(state) })),
  withApollo,
)(({ client, isLoggedIn, children }) => {
  const [value, setValue] = useState({
    educationTags: [],
  });

  useEffect(() => {
    const fetchEduTags = async () => {
      const {
        data: { educationTags },
      } = await client.query({ query: getEducationTags });
      setValue(value => ({ ...value, educationTags }));
    };

    if (isLoggedIn) {
      fetchEduTags();
    }
  }, [client, isLoggedIn]);

  return <GlobalDataContext.Provider value={value}>{children}</GlobalDataContext.Provider>;
});

export const withGlobalData = WrappedComponent => {
  return props => (
    <GlobalDataContext.Consumer>
      {context => <WrappedComponent {...props} globalData={context} />}
    </GlobalDataContext.Consumer>
  );
};
